import React, { Component } from 'react';
import './MaterialOption.css';

class MaterialOption extends Component {

    constructor(props) {
        super(props);
        this._onClick = this._onClick.bind(this);
    }

    _onClick(event) {
        this.props.onClick(event, this.props.value);
    }

    render() {
        return (
            <div className={"materialOption" + (this.props.checked ? " checked" : "")} onClick={this._onClick}>
                <img src={this.props.value.thumbnail} alt={this.props.value.label} />
            </div>
        );
    }
}

export default MaterialOption;


// WEBPACK FOOTER //
// ./src/MaterialOption.js